import { useQuery } from "@tanstack/react-query";

import type { ApiClient } from "../client";
import { useApiClient } from "../useApiClient";

export const DAY_SESSIONS_QUERY_KEY = ["day-sessions"] as const;

// Filter + pagination params for GET /api/trades/day-sessions (ADR 0032).
// The date range bounds the SESSION (UTC close) date, applied identically to
// the headers, totals, and rows. Pagination is by whole session day.
export type ListDaySessionsQuery = {
  account_id?: string[];
  strategy_id?: string;
  tag_id?: string;
  closed_after?: string;
  closed_before?: string;
  day_limit?: number;
  day_offset?: number;
  window_minutes?: number;
  min_run?: number;
};

// Shared query definition reused by the hook and by nav prefetch.
export function daySessionsQueryOptions(
  client: ApiClient,
  params: ListDaySessionsQuery = {},
) {
  return {
    queryKey: [...DAY_SESSIONS_QUERY_KEY, params],
    queryFn: async () => {
      const { data, error } = await client.GET("/api/trades/day-sessions", {
        params: { query: params },
      });
      if (error !== undefined) {
        throw new Error("Failed to list day sessions");
      }
      return data;
    },
  };
}

export function useDaySessions(params: ListDaySessionsQuery = {}, enabled = true) {
  const client = useApiClient();
  return useQuery({
    ...daySessionsQueryOptions(client, params),
    enabled,
  });
}
